import React from "react";
import {
  isWebDesktop,
  isWebMobile,
} from "@microdoing/shared/utils/deviceDetectors";
import normalize from "app/utils/normalize";

const styles = {
  audio: {
    maxWidth: isWebMobile ? normalize(280) : "auto",
    backgroundColor: "white",
    width: isWebDesktop && 280,
  },
};

interface Props {
  soundUrl: string;
  hasDarkBackground?: boolean;
}

const AudioMessage = ({ soundUrl }: Props) => {
  return <audio id="audio" controls src={soundUrl} style={styles.audio} />;
};

export default AudioMessage;
